function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var NOLAN_PER_SAITO = 100000000n;
var _require = require('./transaction-types'),
  formatTransactionTypeName = _require.formatTransactionTypeName,
  formatSlipTypeName = _require.formatSlipTypeName;
var _require2 = require('./ui/tx/json-tree'),
  renderJsonTree = _require2.renderJsonTree;
var _require3 = require('./tx-actions'),
  hasP2shUnlockTargets = _require3.hasP2shUnlockTargets;
var _require4 = require('./nft-tuples'),
  slipField = _require4.slipField,
  isBoundSlip = _require4.isBoundSlip,
  nolanFromNonBoundSlips = _require4.nolanFromNonBoundSlips,
  nftQuantityFromSlips = _require4.nftQuantityFromSlips;

// TransactionType::SPV — the placeholder type a full node substitutes for
// transactions that are not relevant to a lite client when it generates a lite
// block. Their presence means we are looking at a reduced (SPV) copy of a block
// rather than the full block.
var SPV_TRANSACTION_TYPE = 5;
function isSpvTransaction(tx) {
  var _tx$type;
  var type = (_tx$type = tx === null || tx === void 0 ? void 0 : tx.type) !== null && _tx$type !== void 0 ? _tx$type : tx === null || tx === void 0 ? void 0 : tx.transaction_type;
  if (type == null || type === '') {
    return false;
  }
  return Number(type) === SPV_TRANSACTION_TYPE || String(type) === 'SPV';
}
function esc(app, value) {
  return app.browser.escapeHTML(String(value !== null && value !== void 0 ? value : ''));
}
function decodeTxMsg(tx) {
  if (tx !== null && tx !== void 0 && tx.msg && _typeof(tx.msg) === 'object' && Object.keys(tx.msg).length > 0) {
    return tx.msg;
  }
  var buffer = tx === null || tx === void 0 ? void 0 : tx.buffer;
  if (!buffer) {
    return null;
  }
  try {
    var decoded = '';
    if (typeof buffer === 'string') {
      if (typeof atob === 'function') {
        decoded = atob(buffer);
      } else if (typeof Buffer !== 'undefined') {
        decoded = Buffer.from(buffer, 'base64').toString('utf-8');
      }
    }
    if (!decoded) {
      return null;
    }
    return JSON.parse(decoded);
  } catch (err) {
    return null;
  }
}
function formatTxMsgPreview(app, msg) {
  if (msg == null) {
    return null;
  }
  try {
    var text = typeof msg === 'string' ? msg : JSON.stringify(msg, null, 2);
    return esc(app, text);
  } catch (err) {
    return esc(app, String(msg));
  }
}
function isAnonymousUsername(name, publicKey) {
  if (!name || name === '—') {
    return true;
  }
  if (name === publicKey) {
    return true;
  }
  return String(name).startsWith('Anon-');
}
function displayName(app, publicKey) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var key = String(publicKey || '').trim();
  if (!key) {
    return '—';
  }
  var username = app.keychain.returnUsername(key);
  if (!isAnonymousUsername(username, key)) {
    return username;
  }
  if (options.full) {
    return key;
  }
  return truncatePublicKey(key, 16);
}
function formatPublicKeyDisplay(app, publicKey) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var key = String(publicKey || '').trim();
  if (!key) {
    return '—';
  }
  var username = app.keychain.returnUsername(key);
  if (!isAnonymousUsername(username, key)) {
    var truncated = truncatePublicKey(key, 16);
    return esc(app, "".concat(username, " (").concat(truncated, ")"));
  }
  if (options.full) {
    return esc(app, key);
  }
  return esc(app, truncatePublicKey(key, 16));
}
function buildPublicKeyLink(app, publicKey) {
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var key = String(publicKey || '').trim();
  if (!key) {
    return '—';
  }
  var inner = label != null ? esc(app, label) : formatPublicKeyDisplay(app, key, options);
  var href = "/explorer/address/".concat(encodeURIComponent(key));
  return "<a href=\"".concat(href, "\" class=\"explorer-link explorer-pubkey-link\" data-public-key=\"").concat(esc(app, key), "\">").concat(inner, "</a>");
}
function formatAbsoluteTime(timestamp) {
  var ts = Number(timestamp);
  if (!Number.isFinite(ts) || ts <= 0) {
    return '';
  }
  var ms = ts > 1e12 ? ts : ts * 1000;
  try {
    return new Date(ms).toISOString().replace('T', ' ').replace(/\.\d{3}Z$/, ' UTC');
  } catch (err) {
    return '';
  }
}
function formatOptionalSaito(app, nolan) {
  if (nolan == null || nolan === '') {
    return '—';
  }
  return esc(app, formatSaito(nolan));
}
function formatOptionalBigInt(app, value) {
  if (value == null || value === '') {
    return '—';
  }
  try {
    return esc(app, String(value));
  } catch (err) {
    return '—';
  }
}
function bytesToHex(bytes) {
  var arr = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  var hex = '';
  for (var i = 0; i < arr.length; i++) {
    hex += arr[i].toString(16).padStart(2, '0');
  }
  return hex;
}
function enrichBlockCryptoFromSerialize(block, parsed) {
  if (!parsed) {
    return parsed;
  }
  if (parsed.merkle_root && parsed.signature) {
    return parsed;
  }
  try {
    if (typeof (block === null || block === void 0 ? void 0 : block.serialize) !== 'function') {
      return parsed;
    }
    var bytes = block.serialize();
    var u8 = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
    if (u8.length < 181) {
      return parsed;
    }
    if (!parsed.merkle_root) {
      parsed.merkle_root = bytesToHex(u8.subarray(85, 117));
    }
    if (!parsed.signature) {
      parsed.signature = bytesToHex(u8.subarray(117, 181));
    }
  } catch (err) {
    // ignore missing crypto fields
  }
  return parsed;
}
function enrichBlockFromWrapper(block, parsed) {
  if (!block || typeof block.toJson !== 'function' || !parsed) {
    return parsed;
  }
  var fieldMap = [['total_fees', 'totalFees'], ['total_fees_cumulative', 'totalFeesCumulative'], ['burnfee', 'burnFee'], ['total_work', 'totalWork'], ['total_payout_routing', 'totalPayoutRouting'], ['total_payout_treasury', 'totalPayoutTreasury'], ['total_payout_mining', 'totalPayoutMining'], ['total_payout_graveyard', 'totalPayoutGraveyard'], ['total_payout_atr', 'totalPayoutAtr'], ['fee_per_byte', 'feePerByte'], ['avg_fee_per_byte', 'avgFeePerByte'], ['in_longest_chain', 'inLongestChain'], ['has_golden_ticket', 'hasGoldenTicket'], ['has_fee_transaction', 'hasFeeTransaction'], ['difficulty', 'difficulty']];
  for (var i = 0; i < fieldMap.length; i++) {
    var _fieldMap$i = _slicedToArray(fieldMap[i], 2),
      key = _fieldMap$i[0],
      getter = _fieldMap$i[1];
    try {
      if (block[getter] != null) {
        var val = block[getter];
        parsed[key] = typeof val === 'bigint' ? val.toString() : val;
      }
    } catch (err) {
      // ignore missing getters
    }
  }
  try {
    if (typeof block.serialize === 'function') {
      var _ref, _bytes$byteLength;
      var bytes = block.serialize();
      parsed.block_size = (_ref = (_bytes$byteLength = bytes === null || bytes === void 0 ? void 0 : bytes.byteLength) !== null && _bytes$byteLength !== void 0 ? _bytes$byteLength : bytes === null || bytes === void 0 ? void 0 : bytes.length) !== null && _ref !== void 0 ? _ref : null;
    }
  } catch (err) {
    // ignore
  }
  return enrichBlockCryptoFromSerialize(block, parsed);
}
function truncateHash(hash) {
  var head = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var tail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
  if (!hash || typeof hash !== 'string') {
    return '';
  }
  if (hash.length <= head + tail + 3) {
    return hash;
  }
  return "".concat(hash.slice(0, head), "...").concat(hash.slice(-tail));
}

// Public keys are never truncated in the middle: keep the leading characters and
// append an ellipsis from the right only, so the start of the key stays readable.
function truncatePublicKey(key) {
  var head = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  var value = String(key || '').trim();
  if (!value) {
    return '';
  }
  if (value.length <= head + 3) {
    return value;
  }
  return "".concat(value.slice(0, head), "...");
}
var SAITO_MILLION = 1000000n;
var SAITO_BILLION = 1000000000n;

/** Protocol parameters and other non-monetary counters — never abbreviated. */
var EXPLORER_INTEGER_ONLY_KEYS = new Set(['burn_fee', 'difficulty']);
function formatExplorerInteger(value) {
  if (value == null || value === '') {
    return '—';
  }
  try {
    return BigInt(value).toLocaleString('en-US');
  } catch (err) {
    return String(value);
  }
}
function formatAbbreviatedQuotient(scaled) {
  var whole = scaled / 100n;
  var frac = scaled % 100n;
  if (frac === 0n) {
    return whole.toLocaleString('en-US');
  }
  if (frac % 10n === 0n) {
    return "".concat(whole.toLocaleString('en-US'), ".").concat((frac / 10n).toString());
  }
  return "".concat(whole.toLocaleString('en-US'), ".").concat(frac.toString().padStart(2, '0'));
}
function canAbbreviateWithTwoDecimals(value, unit) {
  return unit > 0n && value * 100n % unit === 0n;
}

/**
 * Format a whole-number SAITO amount for display.
 * Abbreviates to million/billion only when the quotient needs at most two decimal places.
 */
function formatMonetaryWhole(whole) {
  if (whole < SAITO_MILLION) {
    return whole.toLocaleString('en-US');
  }
  if (whole >= SAITO_BILLION) {
    if (canAbbreviateWithTwoDecimals(whole, SAITO_BILLION)) {
      var scaled = whole * 100n / SAITO_BILLION;
      return "".concat(formatAbbreviatedQuotient(scaled), " billion");
    }
    return whole.toLocaleString('en-US');
  }
  if (canAbbreviateWithTwoDecimals(whole, SAITO_MILLION)) {
    var _scaled = whole * 100n / SAITO_MILLION;
    return "".concat(formatAbbreviatedQuotient(_scaled), " million");
  }
  return whole.toLocaleString('en-US');
}

/**
 * Format a NOLAN balance using Explorer monetary display rules (no unit suffix).
 */
function formatNolanAsExplorerCurrency(nolan) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (nolan == null || nolan === '') {
    return '—';
  }
  var amount;
  try {
    amount = BigInt(nolan);
  } catch (err) {
    return String(nolan);
  }
  var whole = amount / NOLAN_PER_SAITO;
  var frac = amount % NOLAN_PER_SAITO;
  if (frac === 0n) {
    return options.abbreviate === false ? whole.toLocaleString('en-US') : formatMonetaryWhole(whole);
  }
  var fracStr = frac.toString().padStart(8, '0').replace(/0+$/, '');
  return "".concat(whole.toLocaleString('en-US'), ".").concat(fracStr);
}
function formatSaito(nolan) {
  try {
    var amount = BigInt(nolan !== null && nolan !== void 0 ? nolan : 0);
    var whole = amount / NOLAN_PER_SAITO;
    var frac = amount % NOLAN_PER_SAITO;
    if (frac === 0n) {
      return "".concat(formatMonetaryWhole(whole), " SAITO");
    }
    var fracStr = frac.toString().padStart(8, '0').replace(/0+$/, '');
    return "".concat(whole.toLocaleString('en-US'), ".").concat(fracStr, " SAITO");
  } catch (err) {
    return '0 SAITO';
  }
}
function formatTimeAgo(app, timestamp) {
  var ts = Number(timestamp);
  if (!Number.isFinite(ts) || ts <= 0) {
    return '';
  }
  var seconds = ts > 1e12 ? Math.floor(ts / 1000) : ts;
  return app.browser.formatTimeDifference(seconds);
}
function txSaitoOutputAmount(tx) {
  return nolanFromNonBoundSlips((tx === null || tx === void 0 ? void 0 : tx.to) || []);
}
function formatNftUnits(amount) {
  try {
    var units = BigInt(amount !== null && amount !== void 0 ? amount : 0);
    var suffix = units === 1n ? 'unit' : 'units';
    return "".concat(units.toLocaleString('en-US'), " ").concat(suffix);
  } catch (err) {
    return '0 units';
  }
}
function txPrimaryFrom(tx) {
  var _fromSlips$;
  var fromSlips = (tx === null || tx === void 0 ? void 0 : tx.from) || [];
  if (!fromSlips.length) {
    return '';
  }
  return ((_fromSlips$ = fromSlips[0]) === null || _fromSlips$ === void 0 ? void 0 : _fromSlips$.publicKey) || '';
}
function txPrimaryTo(tx) {
  var _toSlips$;
  var toSlips = (tx === null || tx === void 0 ? void 0 : tx.to) || [];
  if (!toSlips.length) {
    return '';
  }
  return ((_toSlips$ = toSlips[0]) === null || _toSlips$ === void 0 ? void 0 : _toSlips$.publicKey) || '';
}
function formatBlocksForTeaser(app) {
  var blocks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return blocks.filter(Boolean).map(function (block) {
    var _block$id;
    var txCount = Array.isArray(block.transactions) ? block.transactions.length : null;
    return {
      number: esc(app, (_block$id = block.id) !== null && _block$id !== void 0 ? _block$id : ''),
      hash: esc(app, block.hash || ''),
      hashRaw: block.hash || '',
      previousHash: esc(app, block.previous_block_hash || '—'),
      previousHashRaw: block.previous_block_hash || '',
      time: esc(app, formatTimeAgo(app, block.timestamp)),
      miner: buildPublicKeyLink(app, block.creator, block.creator),
      minerRaw: esc(app, block.creator || ''),
      txns: txCount === null ? '…' : esc(app, String(txCount)),
      duration: '—',
      isLongestChain: Boolean(block.in_longest_chain),
      hasGoldenTicket: Boolean(block.has_golden_ticket)
    };
  });
}
function extractTransactionsFromBlocks() {
  var blocks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var txs = [];
  for (var i = 0; i < blocks.length; i++) {
    var _block$transactions;
    var block = blocks[i];
    if (!(block !== null && block !== void 0 && (_block$transactions = block.transactions) !== null && _block$transactions !== void 0 && _block$transactions.length)) {
      continue;
    }
    for (var j = 0; j < block.transactions.length; j++) {
      var tx = block.transactions[j];
      txs.push(_objectSpread(_objectSpread({}, tx), {}, {
        block_hash: block.hash,
        block_timestamp: block.timestamp,
        block_id: block.id
      }));
    }
  }
  txs.sort(function (a, b) {
    var _ref2, _a$timestamp, _ref3, _b$timestamp;
    var ta = Number((_ref2 = (_a$timestamp = a.timestamp) !== null && _a$timestamp !== void 0 ? _a$timestamp : a.block_timestamp) !== null && _ref2 !== void 0 ? _ref2 : 0);
    var tb = Number((_ref3 = (_b$timestamp = b.timestamp) !== null && _b$timestamp !== void 0 ? _b$timestamp : b.block_timestamp) !== null && _ref3 !== void 0 ? _ref3 : 0);
    return tb - ta;
  });
  return txs;
}
function formatTransactionsForTeaser(app) {
  var transactions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  return transactions.slice(0, limit).map(function (tx) {
    var _tx$timestamp, _tx$type2;
    var from = txPrimaryFrom(tx);
    var to = txPrimaryTo(tx);
    return {
      // Render full values and let the flexible card fields truncate only when needed.
      hash: esc(app, tx.signature || tx.hash || ''),
      signature: esc(app, tx.signature || tx.hash || ''),
      blockHash: esc(app, tx.block_hash || ''),
      blockId: esc(app, tx.block_id != null ? String(tx.block_id) : ''),
      time: esc(app, formatTimeAgo(app, (_tx$timestamp = tx.timestamp) !== null && _tx$timestamp !== void 0 ? _tx$timestamp : tx.block_timestamp)),
      type: esc(app, formatTransactionTypeName((_tx$type2 = tx.type) !== null && _tx$type2 !== void 0 ? _tx$type2 : tx.transaction_type)),
      from: buildPublicKeyLink(app, from, from),
      to: buildPublicKeyLink(app, to, to),
      amount: esc(app, formatTransactionAmountBadge(tx))
    };
  });
}
function formatTransactionAmountBadge(tx) {
  var saitoOut = txSaitoOutputAmount(tx);
  if (saitoOut > 0n) {
    return formatSaito(saitoOut);
  }
  var nftQty = nftQuantityFromSlips((tx === null || tx === void 0 ? void 0 : tx.to) || []);
  if (nftQty > 0n) {
    return formatNftUnits(nftQty);
  }
  return formatSaito(0);
}
function slipUtxoKey(slip) {
  return String(slipField(slip, 'utxoKey', 'utxo_key') || '').trim();
}
function slipCreatedIn(app, slip) {
  var block = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var rawId = slipField(slip, 'blockId', 'block_id');
  var slipId = rawId != null && String(rawId) !== '' && String(rawId) !== '0' ? String(rawId) : '';
  var blockId = slipId || ((block === null || block === void 0 ? void 0 : block.id) != null ? String(block.id) : '');
  var blockHash = blockId && block !== null && block !== void 0 && block.hash && String(block.id) === blockId ? String(block.hash) : '';
  return {
    createdBlockId: esc(app, blockId),
    createdBlockLabel: esc(app, blockId ? formatExplorerInteger(blockId) : '—'),
    createdBlockHref: blockId ? "/explorer/block/".concat(encodeURIComponent(blockId)) : '',
    createdBlockHash: blockHash ? esc(app, truncateHash(blockHash, 6, 6)) : '',
    createdBlockHashRaw: esc(app, blockHash)
  };
}
function slipDisplay(app, slip) {
  var ordinal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var block = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var slipType = slipField(slip, 'type', 'slip_type');
  var rawKey = String(slipField(slip, 'publicKey', 'public_key') || '');
  var utxoKey = slipUtxoKey(slip);
  var created = slipCreatedIn(app, slip, block);
  return _objectSpread(_objectSpread({
    role: isBoundSlip(slip) ? 'bound' : 'saito',
    ordinal: esc(app, String(ordinal)),
    publicKey: buildPublicKeyLink(app, rawKey, rawKey),
    publicKeyRaw: esc(app, rawKey),
    slipType: esc(app, String(formatSlipTypeName(slipType) || '').toUpperCase())
  }, created), {}, {
    utxoKeyRaw: esc(app, utxoKey)
  });
}
function formatSlipRows(app) {
  var slips = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var block = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return slips.map(function (slip, index) {
    return slipDisplay(app, slip, index, block);
  });
}
function formatTransactionForBlockPage(app, tx) {
  var _tx$type3, _ref4, _tx$block_id, _ref5, _tx$block_hash, _tx$total_fees, _tx$total_fees2;
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var block = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var signature = (tx === null || tx === void 0 ? void 0 : tx.signature) || (tx === null || tx === void 0 ? void 0 : tx.hash) || '';
  var txType = (_tx$type3 = tx === null || tx === void 0 ? void 0 : tx.type) !== null && _tx$type3 !== void 0 ? _tx$type3 : tx === null || tx === void 0 ? void 0 : tx.transaction_type;
  var txMsg = decodeTxMsg(tx);
  var fromSlips = Array.isArray(tx === null || tx === void 0 ? void 0 : tx.from) ? tx.from : [];
  var toSlips = Array.isArray(tx === null || tx === void 0 ? void 0 : tx.to) ? tx.to : [];
  var timeAbsolute = formatAbsoluteTime(tx === null || tx === void 0 ? void 0 : tx.timestamp);
  var timeDetail = timeAbsolute || '—';
  var inputCount = fromSlips.length;
  var outputCount = toSlips.length;
  var saitoIn = nolanFromNonBoundSlips(fromSlips);
  var saitoOut = nolanFromNonBoundSlips(toSlips);
  var blockId = (_ref4 = (_tx$block_id = tx === null || tx === void 0 ? void 0 : tx.block_id) !== null && _tx$block_id !== void 0 ? _tx$block_id : block === null || block === void 0 ? void 0 : block.id) !== null && _ref4 !== void 0 ? _ref4 : '';
  var blockHash = (_ref5 = (_tx$block_hash = tx === null || tx === void 0 ? void 0 : tx.block_hash) !== null && _tx$block_hash !== void 0 ? _tx$block_hash : block === null || block === void 0 ? void 0 : block.hash) !== null && _ref5 !== void 0 ? _ref5 : '';
  var blockIdStr = blockId != null && String(blockId) !== '' ? String(blockId) : '';
  return {
    index: index,
    hash: esc(app, signature),
    hashFull: esc(app, signature),
    signatureRaw: esc(app, signature),
    signatureFull: esc(app, signature),
    txId: esc(app, String(index + 1)),
    time: esc(app, formatTimeAgo(app, tx === null || tx === void 0 ? void 0 : tx.timestamp)),
    timeAbsolute: esc(app, timeAbsolute),
    timeDetail: esc(app, timeDetail),
    inputCount: inputCount,
    outputCount: outputCount,
    inputs: esc(app, inputCount ? "".concat(inputCount, " input").concat(inputCount === 1 ? '' : 's') : '0 inputs'),
    outputs: esc(app, outputCount ? "".concat(outputCount, " output").concat(outputCount === 1 ? '' : 's') : '0 outputs'),
    ioSummary: esc(app, "".concat(inputCount, " input").concat(inputCount === 1 ? '' : 's', " \xB7 ").concat(outputCount, " output").concat(outputCount === 1 ? '' : 's')),
    saitoIn: esc(app, formatSaito(saitoIn)),
    saitoOut: esc(app, formatSaito(saitoOut)),
    fee: esc(app, formatSaito((_tx$total_fees = tx === null || tx === void 0 ? void 0 : tx.total_fees) !== null && _tx$total_fees !== void 0 ? _tx$total_fees : 0)),
    type: esc(app, formatTransactionTypeName(txType)),
    typeRaw: esc(app, String(txType !== null && txType !== void 0 ? txType : '')),
    fees: esc(app, formatSaito((_tx$total_fees2 = tx === null || tx === void 0 ? void 0 : tx.total_fees) !== null && _tx$total_fees2 !== void 0 ? _tx$total_fees2 : 0)),
    blockId: esc(app, blockIdStr),
    blockNumber: esc(app, blockIdStr ? formatExplorerInteger(blockIdStr) : '—'),
    blockHash: esc(app, blockHash || ''),
    blockHref: blockIdStr ? "/explorer/block/".concat(encodeURIComponent(blockIdStr)) : '',
    fromSlips: formatSlipRows(app, fromSlips, block),
    toSlips: formatSlipRows(app, toSlips, block),
    hasTxMsg: txMsg != null,
    txMsgHtml: txMsg != null ? renderJsonTree(app, txMsg) : null,
    hasP2shUnlock: hasP2shUnlockTargets(tx)
  };
}
function formatBlockType(block) {
  var blockType = block === null || block === void 0 ? void 0 : block.type;
  if (typeof blockType === 'string') {
    try {
      blockType = JSON.parse(blockType);
    } catch (err) {
      // keep string
    }
  }
  if (blockType == null || blockType === '') {
    return '—';
  }
  return String(blockType).replace(/"/g, '');
}
function buildPreviousBlockLink(app, previousHash) {
  var hash = String(previousHash || '').trim();
  if (!hash || /^0+$/.test(hash)) {
    return '—';
  }
  var safeHash = esc(app, hash);
  return "<a href=\"/explorer/block/".concat(encodeURIComponent(hash), "\" class=\"explorer-link explorer-mono explorer-block-prev-link\" data-block-hash=\"").concat(safeHash, "\">").concat(safeHash, "</a>");
}
function formatBlockSummaryPrimary(app, block) {
  var rows = [];
  var add = function add(label, value) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    rows.push(_objectSpread({
      label: esc(app, label),
      value: value == null || value === '' ? '—' : value
    }, opts));
  };
  var absoluteTime = formatAbsoluteTime(block.timestamp);
  var creator = String(block.creator || '').trim();
  var merkleRoot = String(block.merkle_root || '').trim();
  var signature = String(block.signature || '').trim();
  add('Block Hash', esc(app, block.hash || '—'), {
    mono: true
  });
  add('Timestamp', esc(app, absoluteTime || '—'));
  add('Previous Block', buildPreviousBlockLink(app, block.previous_block_hash), {
    html: true
  });
  add('Creator', creator ? buildPublicKeyLink(app, creator, creator) : '—', {
    html: true,
    mono: true
  });
  add('Merkle Root', merkleRoot ? esc(app, merkleRoot) : '—', {
    mono: true
  });
  add('Signature', signature ? esc(app, signature) : '—', {
    mono: true
  });
  return rows;
}
function formatBlockSummaryBadges(app, block) {
  return {
    goldenTicket: {
      label: esc(app, block.has_golden_ticket ? 'Golden Ticket' : 'No Golden Ticket'),
      active: Boolean(block.has_golden_ticket)
    },
    longestChain: {
      label: esc(app, block.in_longest_chain == null ? 'Chain status unknown' : block.in_longest_chain ? 'Longest Chain' : 'Side branch'),
      active: block.in_longest_chain === true
    }
  };
}
function formatBlockSummaryDetail(app, block) {
  var txCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var rows = [];
  var add = function add(label, value) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    rows.push(_objectSpread({
      label: esc(app, label),
      value: value == null || value === '' ? '—' : value
    }, opts));
  };
  add('Status', esc(app, block.in_longest_chain == null ? 'Unknown' : block.in_longest_chain ? 'Longest chain' : 'Side branch'));
  add('Transactions', esc(app, String(txCount)), {
    numeric: true
  });
  add('Block type', esc(app, formatBlockType(block)));
  add('Burn fee', formatOptionalSaito(app, block.burnfee));
  add('Total fees', formatOptionalSaito(app, block.total_fees));
  add('Cumulative fees', formatOptionalSaito(app, block.total_fees_cumulative));
  add('Routing work', formatOptionalSaito(app, block.total_work));
  add('Routing payout', formatOptionalSaito(app, block.total_payout_routing));
  add('Treasury payout', formatOptionalSaito(app, block.total_payout_treasury));
  add('Mining payout', formatOptionalSaito(app, block.total_payout_mining));
  add('Graveyard payout', formatOptionalSaito(app, block.total_payout_graveyard));
  add('ATR payout', formatOptionalSaito(app, block.total_payout_atr));
  add('Treasury balance', formatOptionalSaito(app, block.treasury));
  add('Graveyard balance', formatOptionalSaito(app, block.graveyard));
  add('Fee per byte', formatOptionalSaito(app, block.fee_per_byte));
  add('Avg fee per byte', formatOptionalSaito(app, block.avg_fee_per_byte));
  add('Block size', block.block_size != null ? esc(app, "".concat(block.block_size, " bytes")) : '—', {
    numeric: true
  });
  add('Fee transaction', esc(app, block.has_fee_transaction ? 'Yes' : 'No'));
  add('Difficulty', formatOptionalBigInt(app, block.difficulty));
  return rows;
}
function formatTransactionsForBlockPage(app) {
  var transactions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var block = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return transactions.filter(Boolean).map(function (tx, index) {
    return formatTransactionForBlockPage(app, tx, index, block);
  });
}
function normalizeBlockRecord(block) {
  if (!block) {
    return null;
  }
  if (typeof block.toJson === 'function') {
    try {
      var parsed = JSON.parse(block.toJson());
      if (Array.isArray(block.transactions) && block.transactions.length) {
        parsed.transactions = block.transactions.map(function (tx) {
          if (typeof (tx === null || tx === void 0 ? void 0 : tx.toJson) === 'function') {
            var txjson = tx.toJson();
            if (typeof (tx === null || tx === void 0 ? void 0 : tx.returnMessage) === 'function') {
              txjson.msg = tx.returnMessage();
            }
            return txjson;
          }
          return tx;
        });
      }
      return enrichBlockCryptoFromSerialize(block, enrichBlockFromWrapper(block, parsed));
    } catch (err) {
      return block;
    }
  }
  return enrichBlockCryptoFromSerialize(block, block);
}
function normalizeBlockTransactions(block) {
  if (!block || !Array.isArray(block.transactions)) {
    return block;
  }
  block.transactions = block.transactions.filter(Boolean);
  return block;
}
function formatBlockForPage(app, rawBlock) {
  var _block$tx_count, _block$id2;
  var txFormatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : formatTransactionsForBlockPage;
  var block = normalizeBlockTransactions(normalizeBlockRecord(rawBlock));
  if (!block) {
    return null;
  }
  var transactions = Array.isArray(block.transactions) ? block.transactions : [];
  var transactionCount = (_block$tx_count = block.tx_count) !== null && _block$tx_count !== void 0 ? _block$tx_count : block.body_available === false ? '—' : transactions.length;
  return {
    number: esc(app, String((_block$id2 = block.id) !== null && _block$id2 !== void 0 ? _block$id2 : '')),
    bodyAvailable: block.body_available !== false,
    transactionCount: esc(app, String(transactionCount)),
    hashDisplay: esc(app, block.hash || ''),
    hasSpvTransactions: transactions.some(isSpvTransaction),
    summaryPrimary: formatBlockSummaryPrimary(app, block),
    summaryBadges: formatBlockSummaryBadges(app, block),
    summaryDetail: formatBlockSummaryDetail(app, block, transactionCount),
    transactions: txFormatter(app, transactions, block)
  };
}
function mergeBlockByHash(blocks, enrichedBlock) {
  if (!(enrichedBlock !== null && enrichedBlock !== void 0 && enrichedBlock.hash)) {
    return blocks;
  }
  var next = blocks.slice();
  for (var i = 0; i < next.length; i++) {
    var _next$i;
    if (((_next$i = next[i]) === null || _next$i === void 0 ? void 0 : _next$i.hash) === enrichedBlock.hash) {
      next[i] = _objectSpread(_objectSpread({}, next[i]), enrichedBlock);
      return next;
    }
  }
  return next;
}
module.exports = {
  truncateHash: truncateHash,
  truncatePublicKey: truncatePublicKey,
  EXPLORER_INTEGER_ONLY_KEYS: EXPLORER_INTEGER_ONLY_KEYS,
  formatExplorerInteger: formatExplorerInteger,
  formatMonetaryWhole: formatMonetaryWhole,
  formatNolanAsExplorerCurrency: formatNolanAsExplorerCurrency,
  formatSaito: formatSaito,
  formatAbsoluteTime: formatAbsoluteTime,
  formatTimeAgo: formatTimeAgo,
  displayName: displayName,
  isAnonymousUsername: isAnonymousUsername,
  buildPublicKeyLink: buildPublicKeyLink,
  formatPublicKeyDisplay: formatPublicKeyDisplay,
  formatBlocksForTeaser: formatBlocksForTeaser,
  formatTransactionsForTeaser: formatTransactionsForTeaser,
  formatBlockForPage: formatBlockForPage,
  formatTransactionsForBlockPage: formatTransactionsForBlockPage,
  formatTransactionForBlockPage: formatTransactionForBlockPage,
  extractTransactionsFromBlocks: extractTransactionsFromBlocks,
  mergeBlockByHash: mergeBlockByHash,
  normalizeBlockRecord: normalizeBlockRecord,
  isSpvTransaction: isSpvTransaction
};